export default __webpack_public_path__ + "static/mrcp-bbd0cd1c81f7763175ba014db47b6114.png";